import axios from 'axios';
export const baseURL = `${process.env.REACT_APP_API}/`
export const DATA_LIMIT = 20
// export const baseURL = `http://localhost:8888/api`
export const adminId = localStorage.getItem("id");
export const gymId = localStorage.getItem("gym");

const http = axios.create({
	baseURL: baseURL,
	timeout: 100000,
	headers: {
		'Content-Type': 'application/json',
		Accept: 'application/json',
	},
});


http.interceptors.request.use(
	async (config) => {
		const token = await localStorage.getItem('token');
		if (token) config.headers.token = `${token}`;
		return config;
	},
	(error) => {
		return Promise.reject(error);
	},
);


export default http;